import React from "react";

export const TickReactionIcon = (props: React.SVGProps<SVGSVGElement>) => (
  <svg
    width="12"
    height="12"
    viewBox="0 0 12 12"
    {...props}
  >
    <path
      d="M11.5419 2.12049C11.7994 1.762 11.737 1.24987 11.3935 0.972329C11.0428 0.688906 10.5419 0.764291 10.2795 1.12957L4.54399 9.11368L1.65149 6.04587C1.34241 5.71806 0.836155 5.71806 0.52708 6.04587C0.224307 6.36699 0.224307 6.88303 0.527079 7.20416L4.06278 10.9541C4.22277 11.1238 4.44712 11.2146 4.67877 11.1981C4.91025 11.1816 5.11998 11.06 5.25616 10.8705L11.5419 2.12049Z"
      fill="currentColor"
      stroke="currentColor"
      strokeWidth="0.4"
      strokeLinejoin="round"
    />
  </svg>
);
